import React from 'react';
import { StyledLoading, StyledIcon } from './styledLoading';

interface ILoadingProps {
  className?: string;
  $height?: string;
}

const Loading = ({ className, $height }: ILoadingProps): JSX.Element => (
  <StyledLoading $height={$height} className={className}>
    <StyledIcon />
  </StyledLoading>
);

export default Loading;
